/// <reference path="../../../app.definition.ts" />
import { SIGNATURE_FLOW_UNITS } from "@common/model/constants";
import angular from "angular";
import {BroadcastService} from "@common/service/broadcast.service";

interface IDocumentSignatureBadge {
    signStatus: number;
    documentId: number;
    isPending: boolean;
    isSigned: boolean;
    init(): void;
}
class DocumentSignatureBadgeController implements IDocumentSignatureBadge {
    signStatus: number;
    documentId: number;
    isPending: boolean = false;
    isSigned: boolean = false;

    static $inject = ['$scope','BroadcastService'];
    constructor(private $scope: ng.IScope,private BroadcastService: BroadcastService) {
        this.BroadcastService.registerCallBack(
            "update-signature-badge",
            $scope.$id,
            (documentId, newSignStatus) => {
                // Only update if this event is for THIS document
                if (this.documentId === documentId) {
                    this.signStatus = newSignStatus;
                    this.resolveSignatureBadgeStatus();
                    this.$scope.$applyAsync();
                }
                // Otherwise, ignore the event
            }
        );


        $scope.$on("$destroy", function () {
            BroadcastService.removeCallBack("update-signature-badge", $scope.$id);
        });
    }

    /**
     * Initialize the badge status after bindings are available
     */
    init(): void {
        this.resolveSignatureBadgeStatus();
    }

    isLinkActive(signStatus: number, factor: any): boolean {
        let result = signStatus & factor;
        return result == factor;
    }

    resolveSignatureBadgeStatus(): void {
        // Reset flags
        this.isPending = false;
        this.isSigned = false;

        // Check SIGNED bit (32) first
        if (this.isLinkActive(this.signStatus, SIGNATURE_FLOW_UNITS.SIGNED)) {
            this.isSigned = true;
        }
        // Check ASSIGNED bit (16)
        if (this.isLinkActive(this.signStatus, SIGNATURE_FLOW_UNITS.ASSIGNED_TO_SIGN)) {
            this.isPending = true;
        }
    }

}
function documentSignatureBadge(): ng.IDirective {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'app/common/directive/documentSignatureBadge/template/documentSignatureBadge.directive.html',
        controller: DocumentSignatureBadgeController,
        controllerAs: 'badgeVm',
        bindToController: {
            signStatus: '=',
            documentId: '='
        },
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: IDocumentSignatureBadge): void => {
            controller.init();
        }
    };
}
angular.module('eCareVault.common.directives').directive('documentSignatureBadge', documentSignatureBadge);
